<div
  [formGroup]="formGroup!"
  [class]="(config?.cssClass ? 'mt-3 d-flex gap-2 justify-content-end ' + config!.cssClass : 'mt-3 d-flex gap-2 justify-content-end')"
>
  <button
    class="btn btn-colour-blue-600"
    type="submit"
    [disabled]="config?.disabled"
    [attr.data-testid]="config?.label || 'Submit' + 'Btn'"
    (click)="submit($event)"
  >
    {{ config?.label || 'Submit' }}
  </button>
  <button
    class="btn btn-colour-white border-colour-grayscale-900"
    type="button"
    [disabled]="config?.disabled"
    [attr.data-testid]="config?.cancelButtonLabel || 'Cancel' + 'Btn'"
    (click)="config?.onCancel?.()"
  >
    {{ config?.cancelButtonLabel || 'Cancel' }}
  </button>
</div>
